import { Box, styled } from "@mui/material";
import mobileBackground from "../../../../assets/images/tickets-bg.webp";

const StyledWrapper = styled(Box)(({ theme }) => ({
  maxWidth: theme.breakpoints.values.lg,
  marginTop: "135px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "120px",
  [theme.breakpoints.down("xl")]: {
    maxWidth: theme.breakpoints.values.md,
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: theme.breakpoints.values.sm,
  },
  [theme.breakpoints.down("md")]: {
    position: "relative",
    width: "100%",
    minHeight: "523px",
    marginTop: 0,
    marginBottom: 0,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${mobileBackground})`,
    paddingTop: "0px",
    paddingBottom: "40px",
  },
  ".overlay": {
    display: "none",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      zIndex: 0,
      height: "100%",
      width: "100%",
      display: "block",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
  ".organizers-content": {
    height: "100%",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      alignItems: "center",
      justifyContent: "center",
    },
  },
  ".organizers-title": {
    color: theme.palette.primary.main,
    textAlign: "center",
    marginBottom: "75px",
    [theme.breakpoints.down("md")]: {
      color: theme.palette.white.main,
      marginTop: "60px",
      marginBottom: "30px",
    },
  },
  ".organizers-highlighted": {
    display: "flex",
    justifyContent: "center",
    marginBottom: "65px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

export default StyledWrapper;
